const ENV = process.env.REACT_APP_ENV || 'dev';

interface EnvConfig {
  apiUrl: string;
  analyticsKey?: string;
  socialLoginEnabled?: boolean;
  stripeKey?: string;
  // Add more env-specific variables here
}

const envConfigs: Record<string, EnvConfig> = {
  dev: {
    apiUrl: process.env.REACT_APP_API_URL_DEV || '',
   
  },
  stage: {
    apiUrl: process.env.REACT_APP_API_URL_STAGE || '',
    
  },
  prod: {
    apiUrl: process.env.REACT_APP_API_URL_PROD || '',
    
    
  }
};

export const config = {
  env: ENV,
  isProduction: ENV === 'prod',
  isStaging: ENV === 'stage',
  isDevelopment: ENV === 'dev',
};

export const getEnvConfig = (): EnvConfig => {
  return envConfigs[ENV] || envConfigs.dev;
};